export default {"src":"/_next/static/media/board_masters.e99729b2.svg","height":606,"width":707,"blurWidth":0,"blurHeight":0};